import type { Tone } from '@ui/components/ui';

/** One place that decides what colour a state is, so it reads the same on every page. */
export const callStatusTone = (status?: string): Tone =>
  ({ COMPLETED: 'good', IN_PROGRESS: 'brand', RINGING: 'info', QUEUED: 'neutral', NO_ANSWER: 'neutral', BUSY: 'warn', FAILED: 'bad', VOICEMAIL: 'neutral', TRANSFERRED: 'info', CANCELLED: 'neutral' } as Record<string, Tone>)[status ?? ''] ?? 'neutral';

export const campaignStatusTone = (status?: string): Tone =>
  ({ DRAFT: 'neutral', SCHEDULED: 'info', RUNNING: 'good', PAUSED: 'warn', COMPLETED: 'brand', CANCELLED: 'neutral' } as Record<string, Tone>)[status ?? ''] ?? 'neutral';

export const messageStatusTone = (status?: string): Tone =>
  ({ QUEUED: 'neutral', SENT: 'info', DELIVERED: 'good', FAILED: 'bad', RECEIVED: 'brand', SKIPPED: 'warn' } as Record<string, Tone>)[status ?? ''] ?? 'neutral';

const POSITIVE = new Set(['INTERESTED', 'CALLBACK', 'MEETING_BOOKED', 'APPOINTMENT_BOOKED', 'BOOKED', 'CONFIRMED', 'RESOLVED', 'RESERVATION_REQUESTED']);
const NEGATIVE = new Set(['DO_NOT_CALL', 'FAILED', 'WRONG_NUMBER']);
export const outcomeTone = (outcome?: string, positive?: boolean): Tone =>
  !outcome ? 'neutral' : positive || POSITIVE.has(outcome) ? 'good' : NEGATIVE.has(outcome) ? 'bad' : outcome === 'NOT_INTERESTED' ? 'neutral' : 'info';

export const ROLE_LABEL: Record<string, string> = {
  SUPER_ADMIN: 'Platform admin',
  ORG_OWNER: 'Owner',
  ORG_ADMIN: 'Admin',
  MANAGER: 'Manager',
  BILLING: 'Billing',
  MEMBER: 'Member',
  READ_ONLY: 'Read only'
};
